import React from 'react';
import { Dialog, Stack, Text } from '@fluentui/react';
import { ICallActionGroup } from '../CallActionBar';
import { ICallAction } from 'features/Rooms/RoomView/CallActions';
import CallActionButton from '../Children/CallActionButton/CallActionButton';

interface Props {
    hidden: boolean;
    toggleHideDialog: () => void;
    dialogContentProps: {
        type: any;
        title: string;
        closeButtonAriaLabel: string;
    };
    actions: ICallActionGroup[];
    onActionPressed: (a: ICallAction) => void;
    micIsMuted: boolean;
    cameraIsMuted: boolean;
    sharingIsOn: boolean;
    statsAreVisible: boolean;
    isLocalUserHandRaised: boolean;
    isChatVisible?: boolean;
}

const DialogActions: React.FC<Props> = ({
    hidden,
    toggleHideDialog,
    dialogContentProps,
    actions,
    onActionPressed,
    micIsMuted,
    cameraIsMuted,
    sharingIsOn,
    statsAreVisible,
    isLocalUserHandRaised,
    isChatVisible
}) => {
    return (
        <Dialog hidden={!hidden} onDismiss={toggleHideDialog} dialogContentProps={dialogContentProps}>
            {actions.map((group) =>
                group.actions.length === 0 ? null : (
                    <Stack key={group.key} horizontalAlign="start">
                        {group.actions.map((action) => (
                            <Stack
                                key={action.key}
                                horizontal
                                verticalAlign="center"
                                tokens={{ childrenGap: 8 }}
                                onClick={() => {
                                    onActionPressed(action);
                                    toggleHideDialog();
                                }}
                            >
                                <CallActionButton
                                    action={action}
                                    onPressed={() => null}
                                    micIsMuted={micIsMuted}
                                    cameraIsMuted={cameraIsMuted}
                                    sharingIsOn={sharingIsOn}
                                    statsAreVisible={statsAreVisible}
                                    isLocalUserHandRaised={isLocalUserHandRaised}
                                    isChatVisible={isChatVisible}
                                />
                                <Text>{action.title}</Text>
                            </Stack>
                        ))}
                    </Stack>
                )
            )}
        </Dialog>
    );
};

export default DialogActions;
